import { render, staticRenderFns } from "./foldout.vue?vue&type=template&id=568bc375&scoped=true&"
import script from "./foldout.vue?vue&type=script&lang=js&"
export * from "./foldout.vue?vue&type=script&lang=js&"
import style0 from "./foldout.vue?vue&type=style&index=0&id=568bc375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568bc375",
  null
  
)

export default component.exports